import { render, staticRenderFns } from "./szlk.vue?vue&type=template&id=60117e52&scoped=true"
import script from "./szlk.vue?vue&type=script&lang=js"
export * from "./szlk.vue?vue&type=script&lang=js"
import style0 from "./szlk.vue?vue&type=style&index=0&id=60117e52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60117e52",
  null
  
)

export default component.exports